import { create } from '@porterin/catalyst/src/helper-modules/query-params/QueryParamsConstructor.mjs';
import type { NextRouter } from 'next/router';

import { getRoutePathList, isBrowser } from './CanonicalHelper';

// TS port of CommonHelper.res persistQueryParams.
export function persistQueryParams(url: string, router: NextRouter): string {
  const splitUrl = url.split('?');
  const params = splitUrl.at(-1) ?? '';

  const urlParams: Record<string, string> = {};
  params.split('&').forEach(param => {
    const pair = param.split('=');
    if (pair.length >= 2) {
      urlParams[pair[0] ?? ''] = pair[1] ?? '';
    }
  });

  if (!isBrowser()) {
    return '';
  }

  // fare_estimate_mob deliberately drops query params (parity with .res).
  const segments = getRoutePathList(router.pathname);
  if (segments.length === 1 && segments[0] === 'fare_estimate_mob') {
    return '';
  }

  const args = create(urlParams) as string | undefined;
  return args === undefined ? '' : `?${args}`;
}
